<template>
  <div class="form">
    <div class="wysiwyg" v-if="success_msg">
      <p class="message success small-text">{{ success_msg }}</p>
    </div>

    <form class="form-wrap"
          @submit.prevent="submitForm"
          v-else>

        <div class="form-field col col-12 subject">
            <label for="Subject">Subject *</label>
            <p
               @click="toggleSubjectDropdown"
               :class="[{ placeholder: selectedSubject == 'Select...', 'errors' : errors.subject }, { 'active' : payload.subject }]">
                {{ selectedSubject }}
            </p>
            <img src="/images/icons/form-dropdown.svg" class="icon">
            <ul v-show="showingSubjectDropdown">
                <li
                  v-for="subject in subjects"
                  :key="subject"
                  :class="{ active: subject == selectedSubject }"
                  @click="selectSubject(subject)"
                >
                  {{ subject }}
                </li>
                <!-- <li
                  v-for="subject in subjectSelections"
                  :key="subject"
                  :class="{ active: subject == selectedSubject }"
                  @click="selectSubject(subject)"
                >
                  {{ subject }}
                </li> -->
            </ul>

            <!--<select
              @change="selectSubject($event)"
            >
              <option value="Select...">{{ selectedSubject }}</option>
              <option
                v-for="subject in subjectSelections"
                :key="subject"
                :value="selectedSubject"
              >
                {{ subject }}
              </option>
            </select>-->
        </div>

        <div class="form-field col col-12 text-area-field">
            <label for="message">Message</label>
            <textarea type="text"
              id="message"
              placeholder="Start typing…"
              :class="{ 'error' : errors.message}"
              v-model="payload.message"
              @focus="clearError('message')"
            >
            </textarea>
        </div>

        <div class="form-fields-stack">
            <div class="form-field col col-6">
                <label for="first_name">First Name</label>
                <input type="text"
                  id="first_name"
                  placeholder="Jane"
                  :class="{ 'errors' : errors.first_name}"
                  v-model="payload.first_name"
                  @focus="clearError('first_name')"
                >
            </div>

            <div class="form-field col col-6">
                <label for="last_name">Last Name</label>
                <input type="text"
                  id="last_name"
                  placeholder="Goodhabit"
                  :class="{ 'errors' : errors.last_name}"
                  v-model="payload.last_name"
                  @focus="clearError('last_name')"
                >
            </div>
        </div>

        <div class="form-fields-stack">
            <div class="form-field col col-6">
                <label for="email">Email</label>
                <input type="text"
                  id="email"
                  placeholder="eg. name@email.com"
                  :class="{ 'errors' : errors.email}"
                  v-model="payload.email"
                  @focus="clearError('email')"
                >
            </div>

            <div class="form-field col col-6">
                <label for="phone">Phone</label>
                <input type="number"
                  id="phone"
                  placeholder="eg. 021 100 200"
                  :class="{ 'errors' : errors.phone}"
                  v-model="payload.phone"
                  @focus="clearError('phone')"
                >
            </div>
        </div>

        <div class="form-fields-stack" v-if="showPhysioForms">
            <div class="form-field col col-12">
                <label for="Location">Location *</label>
                <input type="text"
                       id="location"
                       placeholder="Where are you located?"
                       :class="{ 'errors' : errors.location}"
                       v-model="payload.physioLocation"
                       @focus="clearError('location')"
                >
            </div>
        </div>

        <!-- Subject Selection Special Form Fields -->
        <div class="form-fields-stack" v-if="showSubjectForms">
            <div class="form-field">
                <label for="job_title">Job Title *</label>
                <input type="text"
                  id="job_title"
                  :class="{ 'errors' : errors.job_title}"
                  v-model="payload.job_title"
                  @focus="clearError('jobt_title')"
                >
            </div>

            <div class="form-field">
                <label for="organisation">Organisation *</label>
                <input type="text"
                  id="organisation"
                  :class="{ 'errors' : errors.organization}"
                  v-model="payload.organization"
                  @focus="clearError('organization')"
                >
            </div>
        </div>

        <div class="form-field col col-12 location" v-if="showLocationsForms">
            <label for="Location">Location *</label>
            <p
              @click="toggleLocationDropdown"
              :class="{ placeholder: selectedLocation == 'Location...', 'errors' : errors.location }"
            >
              {{ selectedLocation }}
            </p>
            <img src="/images/icons/arrow-down.png" alt="">

            <ul v-show="showingLocationDropdown">
                <li
                  v-for="location in locations"
                  :key="location"
                  :class="{ active: location == selectedLocation }"
                  @click="selectLocation(location)"
                >
                  {{ location }}
                </li>
                <!-- <li
                  v-for="location in locationSelections"
                  :key="location"
                  :class="{ active: location == selectedLocation }"
                  @click="selectLocation(location)"
                >
                  {{ location }}
                </li> -->
            </ul>
        </div>



      <!-- <div class="g-recaptcha" data-sitekey="6LdxAOIZAAAAAH7jP60QqqX9Lzg74YEDQ_35UkGZ"></div> -->

        <!-- <vue-recaptcha
            @verify="onVerify"
            @expired="onExpired"
            :sitekey="siteKey">
        </vue-recaptcha> -->


      <div class="form-field button-field">
        <button class="button light-blue" type="submit" :disabled="isDisabled">Send</button>
      </div>

      <p class="message error small-text" v-if="fail_msg" v-html="fail_msg"></p>
    </form>
  </div>
</template>

<script>
  //import VueRecaptcha from 'vue-recaptcha';
  export default {
    //components: {
    //  VueRecaptcha
    //},
    props: {
      module_type: String,
      siteKey: String,
      subjects: {
        type: Array,
        default: []
      },
      locations: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        isDisabled: false,
        success: false,
        hasErrors: false,
        message: '',
        showingSubjectDropdown: false,
        selectedSubject: 'Select...',
        subjectSelections: [
          "Physiotherapy",
          "Other Rehabilitation Service",
          "Occupational Health",
          "Flu Vaccinations for Workplaces",
          "Gym",
          "Personal Training",
        //   "Psychology and Counselling",
          "Other"
        ],
        showSubjectForms: false,
        showPhysioForms: false,
        showLocationsForms: false,
        showingLocationDropdown: false,
        selectedLocation: 'Select...',
        locationSelections: [
          "Habit Health Majestic (Willis St)",
          "Habit Health Platinum (Johnston St)",
          "Habit Health Evans Bay (Kilbirnie)"
        //   "Habit Health Vero (Shortland St)",
          // "Habit Health North Wharf (Wynyard Qtr)"
        ],
        payload: {
          subject: null,
          message: '',
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          job_title: null,
          organization: null,
          physioLocation: null,
          location: null
        },
        errors: [],
        success_msg: '',
        fail_msg: ''
      }
    },

    mounted () {
      if (window.location.search) {
        var url = decodeURI(window.location)
        var subjectStr = url.match(/subject=([^&]*)/)[0].replace('subject=', '').trim()

        if (subjectStr) {
          let ss = subjectStr.replaceAll('+', ' ')
          this.selectSubject(ss)
        }

        var location = url.match(/location=([^&]*)/)[0].replace('location=', '').trim()

        if (location) {
          let loc = location.replaceAll('+', ' ')
          console.log(loc)
          this.selectLocation(loc)
        }
        // console.log(subjectStr, location)
      }
    },

    methods: {

        onExpired () {
          this.isVerified = false
          this.showMessage = false
          this.message = null
          this.isError = false
        },

        onVerify (response) {
          this.showMessage = false
          this.message = null
          this.isError = false

            if (response) {

              window.axios.post('/api/v1/recaptcha/verify', {recaptchaResponse: response})
                .then(validateResponse => {

                  if (validateResponse.data.success) {
                    this.showMessage = false
                    this.isError = false
                    this.message = null
                    this.isVerified = true
                  } else {
                    this.showMessage = true
                    this.message = 'Invalid captcha'
                    this.isError = true
                    this.isVerified = false
                  }

                })
                .catch(error => {
                  this.showMessage = true
                  this.message = 'Invalid captcha'
                  this.isError = true
                  this.isVerified = false
                })
            }
        },

        toggleSubjectDropdown () {
          this.showingSubjectDropdown = ! this.showingSubjectDropdown
        },

        selectSubject (subject) {
          // console.log(subject)
          this.selectedSubject = subject
          this.showingSubjectDropdown = false
          this.payload.subject = subject

          this.setUrlParam(subject, 'subject')

          if (subject === "Occupational Health" || subject === "Flu Vaccinations for Workplaces") {
            this.showSubjectForms = true
            this.payload.location = null
          } else {
            this.showSubjectForms = false
          }

          if (subject === "Physiotherapy" || subject === "Other Rehabilitation Service" || subject === "Other") {
            this.showPhysioForms = true
            this.payload.physiolocation = null
            this.showSubjectForms = false
          } else {
            this.showPhysioForms = false
          }

          if(subject === "Gym" || subject === "Personal Training") {
            this.showLocationsForms = true
            this.showPhysioForms = false
            this.showSubjectForms = false
          } else {
            this.showLocationsForms = false
            this.showPhysioForms = true
          }

        },

        setUrlParam (val, param) {
          // console.log(window.location)
          const params = new URLSearchParams(window.location.search)
          params.set(param, val)
          window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`))
        },

        toggleLocationDropdown () {
          this.showingLocationDropdown = ! this.showingLocationDropdown
        },

        selectLocation (location) {
          // console.log(location)
          this.selectedLocation = location
          this.showingLocationDropdown = false
          this.payload.location = location

          this.setUrlParam(location, 'location')

          // Clear job title and organization payload
          this.payload.job_title = null
          this.payload.organization = null
        },

      clearError (error) {
        if (this.errors[error]) {
          delete this.errors[error]
        }
      },

      resetForm () {
        for (let field in this.payload) {
          this.payload[field] = ''
        }

        this.success_msg = ''
        this.fail_msg = ''
      },

      submitForm () {
        this.fail_msg = ''
        this.isDisabled = true

        if (!this.payload.subject) {
          this.errors['subject'] = "A subject must be selected"
          this.hasErrors = true
        }

        // if (!this.payload.first_name) {
        //   this.errors['first_name'] = "First Name is required"
        //   this.hasErrors = true
        // }
        // if (!this.payload.last_name) {
        //   this.errors['last_name'] = "Last Name is required"
        //   this.hasErrors = true
        // }
        // if (!this.payload.email) {
        //   this.errors['email'] = "Email is required"
        //   this.hasErrors = true
        // }
        // if (!this.payload.phone) {
        //   this.errors['phone'] = "Phone is required"
        //   this.hasErrors = true
        // }

        if (!this.payload.location && this.showLocationsForms) {
          this.errors['location'] = "A location must be selected"
          this.hasErrors = true
        }

        if (!this.payload.physioLocation && this.showPhysioForms) {
          this.errors['location'] = "Location is required"
          this.hasErrors = true
        }

        if (!this.payload.job_title && this.showSubjectForms) {
          this.errors['job_title'] = "Job title is required"
          this.hasErrors = true
        }

        if (!this.payload.organization && this.showSubjectForms) {
          this.errors['organization'] = "Organization is required"
          this.hasErrors = true
        }

        console.log(this.errors)

        if (this.hasErrors) {
          this.isDisabled = false
          this.hasErrors = false
          return
        }

        let formData = new FormData()

        formData.append('subject', this.payload.subject)
        formData.append('message', this.payload.message)

        formData.append('first_name', this.payload.first_name)
        formData.append('last_name', this.payload.last_name)
        formData.append('email', this.payload.email)
        formData.append('phone', this.payload.phone)

        if(this.showPhysioForms) {
          formData.append('data[physiotherapy_location]', this.payload.physioLocation)
        }

        if(this.showSubjectForms) {
          formData.append('data[job_title]', this.payload.job_title)
          formData.append('data[organization]', this.payload.organization)
        }

        if(this.showLocationsForms) {
          formData.append('data[location]', this.payload.location)
        }

        axios.post('/form-submission/' + this.module_type, formData)
          .then((response) => {
            if (response.data.success) {
                window.location.href = 'thank-you';
              //this.resetForm()
              //this.success_msg = response.data.message
            }
          })
          .catch((error) => {
            if (error.response.status == 422) {
              this.errors = error.response.data.errors
            } else {
              this.fail_msg = 'Something went wrong. Please try again.'
            }
          })
          .then((res) => {
            this.isDisabled = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ContactForm.vue